// eslint-disable-next-line no-unused-vars
const i_order = 5;

export function getColumns(routerName, company_id) {
	let columns = [];

	if (routerName === 'partner') {
		columns = getPartnerColumns(company_id);
	} else if (routerName === 'customers') {
		columns = getCustomerColumns(company_id);
	} else if (routerName === 'vendors') {
		columns = getVendorColumns(company_id);
	}

	return columns.sort((a, b) => a[i_order] - b[i_order]);
}

// *****************************************************************************
// Partner Columns
// *****************************************************************************
function getPartnerColumns(company_id) {
	let columns = [];

	if (company_id === 'beautyplus') {
		columns = beautyplusPartnerColumns();
	} else if (company_id === 'hairplus') {
		columns = hairplusPartnerColumns();
	}

	if (columns.length === 0) {
		columns = defaultPartnerColumns();
	}
	return columns;
}

function defaultPartnerColumns() {
	return [
		['code', 'Code', true, '4.5%', '', 10],
		['memo', 'Memo', true, '3%', 'al_center pointer', 20],
		['name', 'Name', true, '8%', 'truncate', 30],
		['ytd', 'YTD', true, '2%', 'al_right', 40],
		['balance', 'Balance', true, '4.5%', 'al_right', 50],
		['post_check_amount', 'Post Check', true, '4.5%', 'al_right', 60],
		['store_credit_amount', 'Credit', true, '3.5%', 'al_right', 70],
		['sales_group_name', 'Sales Group', true, '6%', '', 80],
		['salesman_id', 'Salesman', true, '4%', '', 90],
		['telephone', 'Phone 1', true, '6%', 'truncate', 100],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 110],
		['fax', 'Fax', true, '6%', 'truncate', 120],
		['email', 'Email', true, '6%', 'truncate', 130],
		['address_detail', 'Address', true, '3%', 'truncate', 140],
		['address_city', 'City', true, '3%', 'truncate', 150],
		['address_state', 'State', true, '1%', 'al_center', 160],
		['address_zipcode', 'Zipcode', true, '3%', '', 170],
		['country', 'Country', true, '1%', 'al_center', 180],
		['grade_code', 'Grade', true, '1%', 'al_center', 190],
		['partner_type', 'Type', true, '1%', 'al_center', 200],
		['owner_name', 'Owner', true, '3%', 'truncate', 210],
		['payment_term_name', 'P.T', true, '3%', 'truncate', 220],
		['blocked', 'Blkd', true, '1%', 'al_center', 230],

		['alt_code', 'Alt Code', false, '3%', '', 240],
		['territory_code', 'Terr', false, '3%', '', 250],
		['last_invoice_date', 'L.I.D', false, '3%', '', 260],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 260],
		['attention_name', 'Contact', false, '3%', '', 270],
	];
}

function beautyplusPartnerColumns() {
	return [
		['code', 'Code', true, '5%', '', 10],
		['memo', 'Memo', true, '3%', 'al_center pointer', 20],
		['name', 'Name', true, '8%', 'truncate', 30],
		['ytd', 'YTD', true, '2%', 'al_right', 40],
		['balance', 'Balance', true, '4.5%', 'al_right', 50],
		['post_check_amount', 'Post Check', true, '4.5%', 'al_right', 60],
		['store_credit_amount', 'Credit', true, '3.5%', 'al_right', 70],
		['sales_group_name', 'Sales Group', true, '6%', 'truncate', 80],
		['salesman_id', 'Salesman', true, '4%', 'truncate', 90],
		['telephone', 'Phone 1', true, '6%', 'truncate', 100],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 110],
		['fax', 'Fax', true, '6%', 'truncate', 120],
		['email', 'Email', true, '6%', 'truncate', 130],
		['address_detail', 'Address', true, '3%', 'truncate', 140],
		['address_city', 'City', true, '3%', 'truncate', 150],
		['address_state', 'State', true, '1%', 'al_center', 160],
		['address_zipcode', 'Zipcode', true, '3%', '', 170],
		['country', 'Country', true, '1%', 'al_center', 180],
		['grade_code', 'Grade', true, '1%', 'al_center', 190],
		['partner_type', 'Type', true, '1%', 'al_center', 200],
		['owner_name', 'Owner', true, '3%', 'truncate', 210],
		['payment_term_name', 'P.T', true, '3%', 'truncate', 220],
		['blocked', 'Blkd', true, '1%', 'al_center', 230],

		['alt_code', 'Alt Code', false, '3%', '', 240],
		['territory_code', 'Terr', false, '3%', '', 250],
		['last_invoice_date', 'L.I.D', false, '3%', '', 260],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 260],
		['attention_name', 'Contact', false, '3%', '', 270],
	];
}
function hairplusPartnerColumns() {
	return [
		['code', 'Code', true, '5%', '', 10],
		['memo', 'Memo', true, '3%', 'al_center pointer', 20],
		['name', 'Name', true, '8%', 'truncate', 30],
		['ytd', 'YTD', true, '2%', 'al_right', 40],
		['balance', 'Balance', true, '4.5%', 'al_right', 50],
		['post_check_amount', 'Post Check', true, '4.5%', 'al_right', 60],
		['store_credit_amount', 'Credit', true, '3.5%', 'al_right', 70],
		['sales_group_name', 'Sales Group', true, '6%', 'truncate', 80],
		['salesman_id', 'Salesman', true, '4%', 'truncate', 90],
		['telephone', 'Phone 1', true, '6%', 'truncate', 100],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 110],
		['fax', 'Fax', true, '6%', 'truncate', 120],
		['email', 'Email', true, '6%', 'truncate', 130],
		['address_detail', 'Address', true, '3%', 'truncate', 140],
		['address_city', 'City', true, '3%', 'truncate', 150],
		['address_state', 'State', true, '1%', 'al_center', 160],
		['address_zipcode', 'Zipcode', true, '3%', '', 170],
		['country', 'Country', true, '1%', 'al_center', 180],
		['grade_code', 'Grade', true, '1%', 'al_center', 190],
		['partner_type', 'Type', true, '1%', 'al_center', 200],
		['owner_name', 'Owner', true, '3%', 'truncate', 210],
		['payment_term_name', 'P.T', true, '3%', 'truncate', 220],
		['blocked', 'Blkd', true, '1%', 'al_center', 230],

		['alt_code', 'Alt Code', false, '3%', '', 240],
		['territory_code', 'Terr', false, '3%', '', 250],
		['last_invoice_date', 'L.I.D', false, '3%', '', 260],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 260],
		['attention_name', 'Contact', false, '3%', '', 270],
	];
}

// *****************************************************************************
// CustomerColumns
// *****************************************************************************
function getCustomerColumns(company_id) {
	let columns = [];

	if (company_id === 'newjigu') {
		columns = newjiguCustomerColumns();
	} else if (company_id === 'minkhair') {
		columns = minkHairCustomerColumns();
	}

	if (columns.length === 0) {
		columns = defaultCustomerColumns();
	}
	return columns;
}

function defaultCustomerColumns() {
	return [
		['code', 'Code', true, '4.5%', '', 10],
		['memo', 'Memo', true, '3%', 'al_center pointer', 20],
		['name', 'Name', true, '8%', 'truncate', 30],
		['ytd', 'YTD', true, '2%', 'al_right', 40],
		['balance', 'Balance', true, '4.5%', 'al_right', 50],
		['post_check_amount', 'Post Check', true, '4.5%', 'al_right', 60],
		['store_credit_amount', 'Credit', true, '3.5%', 'al_right', 70],
		['sales_group_name', 'Sales Group', true, '6%', '', 80],
		['salesman_id', 'Salesman', true, '4%', '', 90],
		['telephone', 'Phone 1', true, '6%', 'truncate', 100],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 110],
		['fax', 'Fax', true, '6%', 'truncate', 120],
		['email', 'Email', true, '6%', 'truncate', 130],
		['address_detail', 'Address', true, '3%', 'truncate', 140],
		['address_city', 'City', true, '3%', 'truncate', 150],
		['address_state', 'State', true, '1%', 'al_center', 160],
		['address_zipcode', 'Zipcode', true, '3%', '', 170],
		['country', 'Country', true, '1%', 'al_center', 180],
		['grade_code', 'Grade', true, '1%', 'al_center', 190],
		['partner_type', 'Type', true, '1%', 'al_center', 200],
		['owner_name', 'Owner', true, '3%', 'truncate', 210],
		['payment_term_name', 'P.T', true, '3%', 'truncate', 220],
		['blocked', 'Blkd', true, '1%', 'al_center', 230],

		['alt_code', 'Alt Code', false, '3%', '', 240],
		['territory_code', 'Terr', false, '3%', '', 250],
		['last_invoice_date', 'L.I.D', false, '3%', '', 260],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 260],
		['attention_name', 'Contact', false, '3%', '', 270],
	];
}

function newjiguCustomerColumns() {
	return [
		['no', 'No', true, '2%', 'al_right', 5],
		['code', 'Code', true, '3%', '', 10],
		['memo', 'Memo', true, '3%', 'al_center pointer', 20],
		['name', 'Name', true, '8%', 'truncate', 30],
		['territory_code', 'Terr', true, '2.5%', '', 31],
		['payment_term_name', 'P.T', true, '3%', 'truncate', 32],
		['ytd', 'YTD', true, '2%', 'al_right', 40],
		['last_invoice_date', 'L.I.D', true, '4%', 'al_center truncate', 41],
		['last_invoice_amount', 'L.I.$', true, '3%', 'al_right', 42],
		['balance', 'Balance', true, '4.5%', 'al_right', 50],
		['post_check_amount', 'Post Check', true, '4.5%', 'al_right', 60],
		['store_credit_amount', 'Credit', true, '3.5%', 'al_right', 70],
		['sales_group_name', 'Sales Group', true, '2.5%', '', 80],
		['salesman_id', 'Salesman', true, '2.5%', '', 90],
		['telephone', 'Phone 1', true, '6%', 'truncate', 100],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 110],
		['fax', 'Fax', true, '5%', 'truncate', 120],
		['email', 'Email', true, '6%', 'truncate', 130],
		['address_detail', 'Address', true, '3%', 'truncate', 140],
		['address_city', 'City', true, '3%', 'truncate', 150],
		['address_state', 'State', true, '1%', 'al_center', 160],
		['address_zipcode', 'Zipcode', true, '3%', 'truncate', 170],
		['country', 'Country', true, '3%', 'al_center truncate', 180],
		['grade_code', 'Grade', true, '1%', 'al_center', 190],
		['partner_type', 'Type', true, '1%', 'al_center', 200],
		['owner_name', 'Owner', true, '3%', 'truncate', 210],

		['blocked', 'Blkd', true, '1%', 'al_center', 230],
		['alt_code', 'Alt Code', false, '3%', '', 240],
		['attention_name', 'Contact', false, '3%', '', 270],
	];
}
function minkHairCustomerColumns() {
	return [
		['code', 'Code', true, '4.5%', '', 10],
		['alt_code', 'Alt Code', true, '3%', '', 20],
		['memo', 'Memo', true, '3%', 'al_center pointer', 30],
		['name', 'Name', true, '8%', 'truncate', 40],
		['ytd', 'YTD', true, '2%', 'al_right', 50],
		['balance', 'Balance', true, '4.5%', 'al_right', 60],
		['post_check_amount', 'Post Check', true, '4.5%', 'al_right', 70],
		['store_credit_amount', 'Credit', true, '3.5%', 'al_right', 80],
		['sales_group_name', 'Sales Group', true, '6%', '', 90],
		['salesman_id', 'Salesman', true, '4%', '', 100],
		['telephone', 'Phone 1', true, '5%', 'truncate', 110],
		['telephone2', 'Phone 2', true, '5%', 'truncate', 120],
		['fax', 'Fax', true, '5%', 'truncate', 130],
		['email', 'Email', true, '5%', 'truncate', 140],
		['address_detail', 'Address', true, '3%', 'truncate', 150],
		['address_city', 'City', true, '3%', 'truncate', 160],
		['address_state', 'State', true, '1%', 'al_center', 170],
		['address_zipcode', 'Zipcode', true, '3%', '', 180],
		['country', 'Country', true, '1%', 'al_center', 190],
		['grade_code', 'Grade', true, '1%', 'al_center', 200],
		['partner_type', 'Type', true, '1%', 'al_center', 210],
		['attention_name', 'Contact', true, '4%', 'truncate', 220],
		['payment_term_name', 'P.T', true, '4%', 'truncate', 230],
		['blocked', 'Blkd', true, '1%', 'al_center', 240],

		['owner_name', 'Owner', false, '3%', 'truncate', 250],
		['territory_code', 'Terr', false, '3%', '', 260],
		['last_invoice_date', 'L.I.D', false, '3%', '', 270],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 280],
	];
}

// *****************************************************************************
// VendorColumns
// *****************************************************************************

function getVendorColumns(company_id) {
	let columns = [];

	if (company_id === 'newjigu') {
		columns = newjiguVendorColumns();
	} else if (company_id === 'minkhair') {
		columns = minkHairVendorColumns();
	}

	if (columns.length === 0) {
		columns = defaultVendorColumns();
	}
	return columns;
}

function defaultVendorColumns() {
	return [
		['code', 'Code', true, '4.5%', '', 10],
		['alt_code', 'Alt Code', true, '3%', '', 20],
		['memo', 'Memo', true, '3%', 'al_center pointer', 30],
		['name', 'Name', true, '8%', 'truncate', 40],
		['telephone', 'Phone 1', true, '6%', 'truncate', 110],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 120],
		['fax', 'Fax', true, '6%', 'truncate', 130],
		['email', 'Email', true, '6%', 'truncate', 140],
		['address_detail', 'Address', true, '3%', 'truncate', 150],
		['address_city', 'City', true, '3%', 'truncate', 160],
		['address_state', 'State', true, '1%', 'al_center', 170],
		['address_zipcode', 'Zipcode', true, '3%', '', 180],
		['country', 'Country', true, '1%', 'al_center', 190],
		['grade_code', 'Grade', true, '1%', 'al_center', 200],
		['partner_type', 'Type', true, '1%', 'al_center', 210],
		['attention_name', 'Contact', true, '4%', 'truncate', 220],
		['payment_term_name', 'P.T', true, '4%', 'truncate', 230],
		['blocked', 'Blkd', true, '1%', 'al_center', 240],

		['ytd', 'YTD', false, '2%', 'al_right', 50],
		['balance', 'Balance', false, '4.5%', 'al_right', 60],
		['post_check_amount', 'Post Check', false, '4.5%', 'al_right', 70],
		['store_credit_amount', 'Credit', false, '3.5%', 'al_right', 80],
		['sales_group_name', 'Sales Group', false, '6%', '', 90],
		['salesman_id', 'Salesman', false, '4%', '', 100],
		['owner_name', 'Owner', false, '3%', 'truncate', 250],
		['territory_code', 'Terr', false, '3%', '', 260],
		['last_invoice_date', 'L.I.D', false, '3%', '', 270],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 280],
	];
}

function minkHairVendorColumns() {
	return [
		['code', 'Code', true, '4.5%', '', 10],
		['alt_code', 'Alt Code', true, '3%', '', 20],
		['memo', 'Memo', true, '3%', 'al_center pointer', 30],
		['name', 'Name', true, '8%', 'truncate', 40],
		['telephone', 'Phone 1', true, '6%', 'truncate', 110],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 120],
		['fax', 'Fax', true, '6%', 'truncate', 130],
		['email', 'Email', true, '6%', 'truncate', 140],
		['address_detail', 'Address', true, '3%', 'truncate', 150],
		['address_city', 'City', true, '3%', 'truncate', 160],
		['address_state', 'State', true, '1%', 'al_center', 170],
		['address_zipcode', 'Zipcode', true, '3%', '', 180],
		['country', 'Country', true, '1%', 'al_center', 190],
		['grade_code', 'Grade', true, '1%', 'al_center', 200],
		['partner_type', 'Type', true, '1%', 'al_center', 210],
		['attention_name', 'Contact', true, '4%', 'truncate', 220],
		['payment_term_name', 'P.T', true, '4%', 'truncate', 230],
		['blocked', 'Blkd', true, '1%', 'al_center', 240],

		['ytd', 'YTD', false, '2%', 'al_right', 50],
		['balance', 'Balance', false, '4.5%', 'al_right', 60],
		['post_check_amount', 'Post Check', false, '4.5%', 'al_right', 70],
		['store_credit_amount', 'Credit', false, '3.5%', 'al_right', 80],
		['sales_group_name', 'Sales Group', false, '6%', '', 90],
		['salesman_id', 'Salesman', false, '4%', '', 100],
		['owner_name', 'Owner', false, '3%', 'truncate', 250],
		['territory_code', 'Terr', false, '3%', '', 260],
		['last_invoice_date', 'L.I.D', false, '3%', '', 270],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 280],
	];
}

function newjiguVendorColumns() {
	return [
		['code', 'Code', true, '4.5%', '', 10],
		['memo', 'Memo', true, '3%', 'al_center pointer', 20],
		['name', 'Name', true, '8%', 'truncate', 30],
		['telephone', 'Phone 1', true, '6%', 'truncate', 40],
		['telephone2', 'Phone 2', true, '6%', 'truncate', 50],
		['fax', 'Fax', true, '6%', 'truncate', 60],
		['email', 'Email', true, '6%', 'truncate', 70],
		['address_detail', 'Address', true, '3%', 'truncate', 80],
		['address_city', 'City', true, '3%', 'truncate', 90],
		['address_state', 'State', true, '1%', 'al_center', 100],
		['address_zipcode', 'Zipcode', true, '3%', '', 110],
		['country', 'Country', true, '1%', 'al_center', 120],
		['grade_code', 'Grade', true, '1%', 'al_center', 130],
		['partner_type', 'Type', true, '1%', 'al_center', 140],
		['owner_name', 'Owner', true, '3%', 'truncate', 150],
		['payment_term_name', 'P.T', true, '4%', 'truncate', 160],
		['blocked', 'Blkd', true, '1%', 'al_center', 170],

		['alt_code', 'Alt Code', false, '3%', '', 180],
		['ytd', 'YTD', false, '2%', 'al_right', 190],
		['balance', 'Balance', false, '4.5%', 'al_right', 200],
		['post_check_amount', 'Post Check', false, '4.5%', 'al_right', 210],
		['store_credit_amount', 'Credit', false, '3.5%', 'al_right', 220],
		['sales_group_name', 'Sales Group', false, '6%', '', 230],
		['salesman_id', 'Salesman', false, '4%', '', 240],
		['attention_name', 'Contact', false, '4%', 'truncate', 250],
		['territory_code', 'Terr', false, '3%', '', 260],
		['last_invoice_date', 'L.I.D', false, '3%', '', 270],
		['last_invoice_amount', 'L.I.$', false, '3%', 'al_right', 280],
	];
}
